import { render, staticRenderFns } from "./MyDonation.vue?vue&type=template&id=999d5696&"
import script from "./MyDonation.vue?vue&type=script&lang=js&"
export * from "./MyDonation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports